<template>
   
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto pb-[80px] px-6 py-6">

    <!-- Loading -->
    <!-- <block-loading v-if="loading"/> -->

    <!-- Not activated -->
    <div v-if="membershipNotActivated && !isSuperUser" class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl">
      <div class="w-full">
          <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
            <p class="text-center text-theme-red">Loyalty is not setup for your business, please contact Tendy support.</p>
          </div>
      </div>
    </div>
    <!-- Activated -->
    <div v-else-if="!membershipNotActivated || isSuperUser">
      <Nav/>

      <div class="p-3 mb-24 bg-[#2B2C32] border-0 rounded-lg">
          <div class="mb-3 flex justify-between">
            <h3 class="text-[24px] text-white font-semibold">Membership Settings</h3>
            <div v-if="can_edit_membership_details">
              <button @click="syncCatalogue()" class="text-sm mr-2 font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-theme-green text-white hover:bg-theme-darkgreen">SYNC CATALOGUE</button>
              <button @click="(loyaltyProgram && loyaltyProgram.id) ? updateProgramSetting() : createProgramSetting()" class="text-sm font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-white hover:text-white hover:bg-theme-darkgreen">SAVE</button>
            </div>
          </div>

          <div class="input-wrapper mb-3">
            <label class="text-xs mb-1 mt-0">Status:</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" :disabled="!isSuperUser" v-model="form.is_active" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.is_active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.is_active ? 'text-theme-green' : 'text-[#F53333]'">{{form.is_active ? 'On' : 'Off'}}</span>
            </label>
          </div>

          
          

          <div class="py-2 grid gap-4 xl:grid-cols-4 grid-cols-1">
            
          <div :class="'input-wrapper ' + (form.name.error_type)">
              <label class="block text-white text-xs mb-1" for="name">Name</label>
              <input @keyup="validateFields(['name'])" v-model="form.name.value" class="block rounded w-full border-none py-2.5 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline text-sm"  placeholder="Loyalty Program Name" type="text">
              <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
            </div>

            <div>

              <file-manager v-model="form.logo_url" classes="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest" label="SELECT" >
                <template v-slot:custom="{ onClick }">
                  <div class="flex flex-row justify-between mt-1">
                    <div class="content-image w-[calc(100%-116px)] h-[100px] my-auto relative" v-if="form.logo_url">
                      <img class=" p-1 min-w-[50px] min-h-[50px] w-full" :src="form.logo_url" />
                    </div>
                    <div v-else class="text-[#878686] text-sm tracking-wider">Select Logo</div>
                    <div class="flex flex-col gap-2">
                      <div v-if="can_edit_membership_details" @click="onClick" class="h-9  w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest">{{ form.logo_url ? 'CHANGE' : 'SELECT'}}</div>
                      <div v-if="can_edit_membership_details" @click="clearLogo" class="h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest">CLEAR</div>
                    </div>
                  </div>
                </template>
              </file-manager>

            </div>

            <div>
              <file-manager v-model="form.card_background_image" classes="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest" label="SELECT1" >
                <template v-slot:custom="{ onClick }">
                  <div class="flex flex-row justify-between mt-1">
                    
                    <div class="content-image w-[calc(100%-116px)] h-[100px] my-auto relative" v-if="form.card_background_image">
                      <img class=" p-1 min-w-[50px] min-h-[50px] w-full" :src="form.card_background_image" />
                    </div>
                    <div v-else class="text-[#878686] text-sm tracking-wider">Select Background</div>
                    <div class="flex flex-col gap-2">
                      <div v-if="can_edit_membership_details" @click="onClick" class="h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest">{{ form.card_background_image ? 'CHANGE' : 'SELECT'}}</div>
                      <div v-if="can_edit_membership_details" @click="clearBackground" class="h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest">CLEAR</div>
                    </div>
                  </div>
                </template>
              </file-manager>
            </div>

          </div>
          
          <div class="py-2 grid gap-4 xl:grid-cols-4 grid-cols-1 mt-3">
            <div :class="'input-wrapper' + (form.primary_color.error_type)">
              <label class="block text-white text-xs ">Primary Color</label>
              <div class="block rounded bg-gray-black w-full text-sm px-1 py-[6px]">
                <label for="membership_primary_color" class="w-full flex">
                  <input class="w-6 bg-transparent rounded" @change="validateFields(['primary_color'])" v-model="form.primary_color.value" id="membership_primary_color" type="color">
                  <span :class="'pl-2 items-center flex ' + (form.primary_color.value ? 'text-white': 'text-theme-878686')">{{ form.primary_color.value ? form.primary_color.value : '-- Select --' }}</span>
                </label>
              </div>
              <p class="field-error label-text mt-1" v-if="form.secondary_color.error_message" v-text="form.secondary_color.error_message"></p>
            </div>

            <div :class="'input-wrapper' + (form.secondary_color.error_type)">
              <label class="block text-white text-xs ">Secondary Color</label>
              <div class="block rounded bg-gray-black w-full text-sm px-1 py-[6px]">
                <label for="membership_secondary_color" class="w-full flex">
                  <input class="w-6 bg-transparent rounded" @change="validateFields(['secondary_color'])" v-model="form.secondary_color.value" id="membership_secondary_color" type="color">
                  <span :class="'pl-2 items-center flex ' + (form.secondary_color.value ? 'text-white': 'text-theme-878686')">{{ form.secondary_color.value ? form.secondary_color.value : '-- Select --' }}</span>
                </label>
              </div>
              <p class="field-error label-text mt-1" v-if="form.secondary_color.error_message" v-text="form.secondary_color.error_message"></p>
            </div>

            <div :class="'input-wrapper' + (form.accent_color.error_type)">
              <label class="block text-white text-xs ">Accent Color</label>
              <div class="block rounded bg-gray-black w-full text-sm px-1 py-[6px]">
                <label for="membership_accent_color" class="w-full flex">
                  <input class="w-6 bg-transparent rounded" @change="validateFields(['accent_color'])" v-model="form.accent_color.value" id="membership_accent_color" type="color">
                  <span :class="'pl-2 items-center flex ' + (form.accent_color.value ? 'text-white': 'text-theme-878686')">{{ form.accent_color.value ? form.accent_color.value : '-- Select --' }}</span>
                </label>
              </div>
              <p class="field-error label-text mt-1" v-if="form.accent_color.error_message" v-text="form.accent_color.error_message"></p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import Nav from "@/views/Membership/Program/Nav.vue";
import LoyaltyProgramApis from "@/controllers/LoyaltyProgramApis";
import LoyaltyProgramBrandingApis from "@/controllers/LoyaltyProgramBrandingApis";
import FileManager from '@/components/manager/filemanager.vue'

export default defineComponent({
  name: "MembershipProgramSetting",
  components: {
    Nav,
    FileManager
  },

  setup() {
    const loading = ref(false);
    const membershipNotActivated = ref(false)
    const snackbar = useSnackbar();
    const loyaltyProgram = <any>ref({});
    const loyaltyBranding = <any>ref({});
    const form = <any>ref({
      // status: false,
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      primary_color: {
        value: '#FFFFFF',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      secondary_color: {
        value: '#FFFFFF',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      accent_color: {
        value: '#FFFFFF',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      is_active: false,
      card_background_image: '',
      logo_url: '',
    });
    return {
      loading,
      membershipNotActivated,
      form,
      snackbar,
      loyaltyProgram,
      loyaltyBranding
    };
  },

  computed: {

    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
    isSuperUser() {
      return Helpers.isSuperUser();
    },

    ...mapGetters({
      vg_selectedBusiness: 'auth/activeBusiness',
    }),
  },
 

  async mounted() {
    this.loading = true;
    let loyaltyProgramRes = await LoyaltyProgramApis.getProgramByCurrentActiveBusiness();
    if(loyaltyProgramRes.status == 200 || loyaltyProgramRes.status == 201) {
      let loyaltyBrandingRes = await LoyaltyProgramBrandingApis.getById(loyaltyProgramRes.data.id);
      this.loyaltyProgram = loyaltyProgramRes.data;
      this.form.is_active = loyaltyProgramRes.data.is_active;
      this.form.name.value = loyaltyProgramRes.data.name;
      if(loyaltyBrandingRes.status == 200 || loyaltyBrandingRes.status == 201) {
        this.loyaltyBranding = loyaltyBrandingRes.data;
        this.form.primary_color.value = loyaltyBrandingRes.data.primary_color;
        this.form.secondary_color.value = loyaltyBrandingRes.data.secondary_color;
        this.form.accent_color.value = loyaltyBrandingRes.data.accent_color;
        this.form.logo_url = loyaltyBrandingRes.data.logo_url;
        this.form.card_background_image = loyaltyBrandingRes.data.card_background_image;
      }
    }else{
      this.membershipNotActivated = true
    }
    this.loading = false;
  },

  methods: {
    clearBackground(){
      this.form.card_background_image = ''
    },
    clearLogo(){
      this.form.logo_url = ''
    },
    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * createProgramSetting
     */
     async createProgramSetting() {
       // validate business field
      let validate = await this.validateFields(['name','primary_color','secondary_color','accent_color']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let loyaltyProgram = await LoyaltyProgramApis.create(true, this.form.name.value);
      if(loyaltyProgram.status  == 201){

        let obj = {
          primary_color: this.form.primary_color.value,
          secondary_color: this.form.secondary_color.value,
          accent_color: this.form.accent_color.value,
          logo_url: this.form.logo_url,
          card_background_image: this.form.card_background_image,
        }

        if(this._lodash.isEmpty(this.loyaltyBranding)) {
          await LoyaltyProgramBrandingApis.create(loyaltyProgram.data.id, obj);
        } else {
          await LoyaltyProgramBrandingApis.update(this.loyaltyProgram.data.payload.id, obj);
        }
         
      } 
      this.snackbar.add({
        type: 'info',
        text: (loyaltyProgram.status == 200 || loyaltyProgram.status == 201) ? loyaltyProgram.data.msg : Helpers.catchErrorMessage(loyaltyProgram.response.data),
        duration: 3000,
      })

      this.va_spinner(false);
      
     
    },


    /**
     * update Program Setting
     */
    async updateProgramSetting() {
       // validate business field
      let validate = await this.validateFields(['name','primary_color','secondary_color','accent_color']);
      if(!validate) {
        return ;
      }
      let loyaltyProgram =  LoyaltyProgramApis.update(this.loyaltyProgram.id, {
        name: this.form.name.value,
        desc: 'My loyalty description',
        is_active: this.form.is_active
      });


      let loyaltyBranding;
      let obj = {
        primary_color: this.form.primary_color.value,
        secondary_color: this.form.secondary_color.value,
        accent_color: this.form.accent_color.value,
        logo_url: this.form.logo_url,
        card_background_image: this.form.card_background_image,
      };

      if(this._lodash.isEmpty(this.loyaltyBranding)) {
        loyaltyBranding = LoyaltyProgramBrandingApis.create(this.loyaltyProgram.id, obj);
      } else {
        loyaltyBranding = LoyaltyProgramBrandingApis.update(this.loyaltyProgram.id, obj);
      }

      const self = this;
      this.va_spinner(true);
      Promise.all([loyaltyProgram, loyaltyBranding]).then(async function (res) {
        self.va_spinner(false);
        self.snackbar.add({
          type: 'info',
          text: res[0].status!==200?res[0].response.data:(res[1].status!==200?res[1].response.data:'Changes Saved'),
          duration: 3000,
        })
      })
    },

    /**
     * Sync catalogue
     */

    async syncCatalogue() {
      this.va_spinner(true);
      let res:any =  await LoyaltyProgramApis.syncCatalogue(this.vg_selectedBusiness.id);
      this.va_spinner(false);
      this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })

    },
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })

  },
});

</script>

